import React, { useState, useEffect, useContext } from "react";
import DataTable from "../components/DataTableComponents";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import LoaderComponent from "../components/admin/LoaderComponent";
import { Box, Modal, TextField, MenuItem } from "@mui/material";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import { maxLengthLimitInput } from "../utils/inputsRules";
import Tooltip from "@mui/material/Tooltip";
import IconUI from "../components/iu/icon_ui";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";

const AreasView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",

    "&:hover": {
      backgroundColor: "#661d40",

    },
    borderRadius: "40px",
  }));

  const [state, setState] = useState({
    areas: [],
    areaSeleccionada: {},
    open: false,
    openModalEliminar: false,
  });

  const [tiposAreaState, setTiposArea] = useState({ data: [] });

  const { showNotification } = useContext(NotificacionContext);

  const [formularioState, setFormularioState] = useState({
    name: "",
    liable: "",
    post: "",
    municipality: "",
    phone: "",
    email: "",
    area_type_id: "",
  });

  const [errors, setErrors] = useState({});

  const openmodal = (data) => {
    const newData = data;
    setEditar({ ...editarState, open: true, data: newData });
  };

  const handleClose = () => {
    setEditar({
      ...editarState,
      open: false,
    });
  };

  const openModalEliminar = (data) => {
    setState({
      ...state,
      openModalEliminar: true,
      areaSeleccionada: data,
    });
  };
  const handleCloseEliminar = () => {
    setState({
      ...state,
      openModalEliminar: false,
    });
  };

  const handleName = (e) => {
    setFormularioState({ ...formularioState, name: e.target.value });
  };
  const handleLiable = (e) => {
    setFormularioState({ ...formularioState, liable: e.target.value });
  };
  const handlePost = (e) => {
    setFormularioState({ ...formularioState, post: e.target.value });
  };
  const handleMunicipality = (e) => {
    setFormularioState({ ...formularioState, municipality: e.target.value });
  };
  const handlePhone = (e) => {
    setFormularioState({ ...formularioState, phone: e.target.value });
  };
  const handleEmail = (e) => {
    setFormularioState({ ...formularioState, email: e.target.value });
  };
  const handleAreaTypeId = (e) => {
    setFormularioState({ ...formularioState, area_type_id: e.target.value });
  };

  const [editarState, setEditar] = useState({
    open: false,
    data: {},
  });

  const handleSeleccionadaName = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, name: e.target.value },
    });
  };
  const handleSeleccionadaLiable = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, liable: e.target.value },
    });
  };
  const handleSeleccionadaPost = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, post: e.target.value },
    });
  };
  const handleSeleccionadaMunicipality = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, municipality: e.target.value },
    });
  };
  const handleSeleccionadaPhone = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, phone: e.target.value },
    });
  };
  const handleSeleccionadaEmail = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, email: e.target.value },
    });
  };
  const handleSeleccionadaAreaTypeId = (e) => {
    setEditar({
      ...editarState,
      data: { ...editarState.data, area_type_id: e.target.value },
    });
  };


  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;

  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.name) {
      newErrors.name = "Este Campo es Requerido";
    }
    if (!formularioState.liable) {
      newErrors.liable = "Este Campo es Requerido";
    }
    if (!formularioState.municipality) {
      newErrors.municipality = "Este Campo es Requerido";
    }
    if (!formularioState.phone) newErrors.phone = "Este campo es requerido";
    else if (formularioState.phone.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    
    if (!formularioState.post) {
      newErrors.post = "Este Campo es Requerido";
    }
    if (formularioState.email !== "") {
      let valido = regexEmail.test(formularioState.email);
      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    }
    if (!formularioState.area_type_id) {
      newErrors.area_type_id = "Este Campo es Requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    if (!editarState.data.name) {
      newErrors.name = "Este Campo es Requerido";
    }
    if (!editarState.data.liable) {
      newErrors.liable = "Este Campo es Requerido";
    }
    if(!editarState.data.municipality) {
      newErrors.municipality = "Este Campo es Requerido";
    }
    if (!editarState.data.phone) newErrors.phone = "Este campo es requerido";
    else if (editarState.data.phone?.length < 10) newErrors.phone = "Favor poner un número de 10 dígitos";
    
    if (!editarState.data.post) {
      newErrors.post = "Este Campo es Requerido";
    }
    if (editarState.data.email !== null &&editarState.data.email !== "") {
      let valido = regexEmail.test(editarState.data.email);
      if (!valido) {
        newErrors.email = "Ingrese un email válido";
      }
    }
    if (!editarState.data.area_type_id) {
      newErrors.area_type_id = "Este Campo es Requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const limpiarForm = () => {
    setFormularioState({
      ...formularioState,
      name: "",
      liable: "",
      post: "",
      municipality: "",
      phone: "",
      email: "",
      area_type_id: "",
    });
  };

  const crearArea = async () => {
    if (validarFormulario()) {
      setLoader({ loading: true });
      const area = await services({
        method: "POST",
        service: "areas",
        body: {
          name: formularioState.name.toUpperCase(),
          liable: formularioState.liable.toUpperCase(),
          post: formularioState.post.toUpperCase(),
          municipality: formularioState.municipality.toUpperCase(),
          phone: formularioState.phone,
          email: formularioState.email.toUpperCase(),
          area_type_id: formularioState.area_type_id,
      
        },
      });
      if (area.status === 201) {
        let areas = await services({
          method: "GET",
          service: `areas`,
          body: null,
        });
        if (areas.status === 200) {
          setLoader({ loading: false });
          setState({ ...state, areas: areas.data });
          showNotification(
            "success",
            "Areas",
            "Se creó área correctamente",
            null,
            4,
          );
          setopenModal(false);
          limpiarForm();
        } else {
          showNotification(
            "error",
            "ups... Algo sucedió",
            "Error al agregar área",
            null,
            4,
          );
          setopenModal(false);
          limpiarForm();
          setLoader({ loading: false });
        }
      } else {
        showNotification(
          "error",
          "Ups... Algo sucedió",
          area.data.message,
          null,
          4,
        );
        setopenModal(false);
        limpiarForm();
        setLoader({ loading: false });
      }
    } else {
      showNotification(
        "error",
        "ups...Error ",
        "Por favor llena todos los campos",
        null,
        4,
      );
    }
  };

  const editarArea = async () => {
    setLoader({ loading: true });
    const body = {
      name: editarState.data.name?.toUpperCase(),
      liable: editarState.data.liable?.toUpperCase(),
      post: editarState.data.post?.toUpperCase(),
      municipality: editarState.data.municipality?.toUpperCase(),
      phone: editarState.data.phone,
      email: editarState.data.email?.toUpperCase(),
      area_type_id: editarState.data.area_type_id,

    };
    if (validarEditar()) {
      const EditArea = await services({
        method: "PUT",
        service: `areas/${editarState.data.id}`,
        body,
      });
      if (EditArea.status === 200) {
        let areas = await services({
          method: "GET",
          service: `areas`,
          body: null,
        });
        if (areas.status === 200) {
          setState({ ...state, areas: areas.data });
          showNotification(
            "success",
            "Areas",
            "Se editó correctamente la área",
            null,
            4,
          );
          setLoader(false);
          setEditar({ ...editarState, open: false });
        } else {
          showNotification(
            "error",
            "Ups...Algo Sucedió",
            "Error al editar",
            null,
            4,
          );
          setLoader(false);
          setEditar({ ...editarState, open: false });
        }
      } else {
        showNotification("error", "Ups... Sucedió", "Error al editar", null, 4);
        setLoader(false);
        setEditar({ ...editarState, open: false });
      }
    } else {
      showNotification(
        "error",
        "Por favor",
        "Verifica los campos marcados",
        null,
        4,
      );
    }
  };

  const eliminarArea = async () => {
    setLoader({ loading: true });
    const eliminarArea = await services({
      method: "DELETE",
      service: `areas/${state.areaSeleccionada.id}`,
      body: null,
    });
    if (eliminarArea) {
      setLoader({ loading: true });
      let areas = await services({
        method: "GET",
        service: `areas`,
        body: null,
      });
      if (areas) {
        setState({
          ...state,
          areas: areas.data,
          openModalEliminar: false,
        });
        showNotification(
          "success",
          "Área Eliminada con Éxito",
          "",
          null,
          4,
        );
        setLoader({ loading: false });
      } else {
        setLoader({ loading: false });
        showNotification(
          "error",
          "Ups...",
          "Error al eliminar la área",
          null,
          4,
        );
        setState({ ...state, openModalEliminar: false });
      }
    } else {
      setLoader({ loading: false });
      showNotification(
        "error",
        "Ups...",
        "Error al eliminar la área",
        null,
        4,
      );
      setState({ ...state, openModalEliminar: false });
    }
  };

  const [loader, setLoader] = useState({
    loading: true,
  });

  const [openModal, setopenModal] = useState(false);

  const mostrarAreas = async () => {
    let areas = await services({
      method: "GET",
      service: `areas`,
      body: null,
    });

    if (areas) {
      setState({ ...state, areas: areas.data });
    }
    setLoader(false);
  };

  const mostrarTiposArea = async () => {
    let area_types = await services({
      method: "GET",
      service: `area-types`,
      body: null,
    });

    if (area_types) {
      setTiposArea({ ...tiposAreaState, data: area_types.data });
    }
    setLoader(false);
  };

  const areasTableData = (state.areas || []).map((area) => ({
    ...area,
    name: area?.name ?? "",
    liable: area?.liable ?? "",
    area_type: area?.type?.name ?? "",
    post: area?.post ?? "",
    municipality: area?.municipality ?? "",
    phone: area?.phone ?? "",
  }));

  const columns = [
    {
      name: "name",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let name = areasTableData[dataIndex].name;
          if (name !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {name}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "liable",
      label: "RESPONSABLE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let liable = areasTableData[dataIndex].liable;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "95px" }}
            >
              {liable}
            </div>
          );
        },
      },
    },
    {
      name: "area_type",
      label: "TIPO DE AREA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let type_area = areasTableData[dataIndex].area_type;
          if (type_area !== null && type_area !== "") {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {type_area}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "post",
      label: "CARGO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let post = state.areas[dataIndex].post;
          if (post !== null && post !== "") {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {post}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "municipality",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipality = state.areas[dataIndex].municipality;
          if (municipality !== null && municipality !== "") {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {municipality}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "phone",
      label: "TELÉFONO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let phone = state.areas[dataIndex].phone;
          if (phone !== null && phone !== "") {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {phone}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",

      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "w-100 d-flex align-items-center justify-content-center "
                  : "w-100 d-flex justify-content-center align-items-center "
              }
            >
              <Tooltip title="EDITAR AREA">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openmodal(state.areas[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineEdit />
                  </IconUI>
                </div>
              </Tooltip>
              <Tooltip title="ELIMINAR AREA">
                <div
                  style={{ height: 30, width: 30, zIndex: 0, marginLeft: 5 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openModalEliminar(state.areas[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineDelete />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      mostrarAreas();

      mostrarTiposArea();
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            sx={{ marginTop: 3 }}
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
          >
            <Grid item>
              <ColorButton
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  setopenModal(true);
                }}
              >
                Añadir Nueva Area
              </ColorButton>
            </Grid>
          </Grid>
        </div>
        <DataTable
          data={areasTableData}
          title={`TABLA DE ÁREAS`}
          columns={columns}
        />

        <Modal
          open={openModal}
          onClose={() => setopenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">NUEVA ÁREA</h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  required
                  fullWidth
                  size="small"
                  error={!!errors.name}
                  helperText={errors.name || ""}
                  id="textFile-nombre"
                  label="NOMBRE ÁREA"
                  variant="outlined"
                  value={formularioState.name.toUpperCase()}
                  onChange={handleName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  required
                  fullWidth
                  size="small"
                  error={!!errors.liable}
                  helperText={errors.liable || ""}
                  id="textFile-nombre"
                  label="RESPONSABLE"
                  variant="outlined"
                  value={formularioState.liable.toUpperCase()}
                  onChange={handleLiable}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="PUESTO"
                  variant="outlined"
                  error={!!errors.post}
                  helperText={errors.post || ""}
                  value={formularioState.post.toUpperCase()}
                  onChange={handlePost}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="MUNICIPIO" 
                  variant="outlined" 
                  select 
                  error={!!errors.municipality}
                  helperText={errors.municipality || ""}
                  value={formularioState.municipality}
                  onChange={handleMunicipality}
                >
                  
                  <MenuItem value="MORELIA">MORELIA</MenuItem>
                  <MenuItem value="APATZINGÁN">APATZINGÁN</MenuItem>
                  <MenuItem value="LÁZARO CÁRDENAS">LÁZARO CÁRDENAS</MenuItem>
                  <MenuItem value="LA PIEDAD">LA PIEDAD</MenuItem>
                  <MenuItem value="SAHUAYO">SAHUAYO</MenuItem>
                  <MenuItem value="URUAPAN">URUAPAN</MenuItem>
                  <MenuItem value="ZAMORA">ZAMORA</MenuItem>
                  <MenuItem value="ZITÁCUARO">ZITÁCUARO</MenuItem>
                  
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  required
                  fullWidth
                  size="small"
                  error={!!errors.phone}
                  helperText={errors.phone || ""}
                  id="textFile-nombre"
                  label="TELÉFONO"
                  variant="outlined"
                  value={formularioState.phone}
                  onChange={handlePhone}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  error={!!errors.email}
                  helperText={errors.email || ""}
                  id="textFile-nombre"
                  label="CORREO ELECTRÓNICO"
                  variant="outlined"
                  value={formularioState.email.toUpperCase()}
                  onChange={handleEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  select
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="TIPO DE ÁREA"
                  variant="outlined"
                  value={formularioState.area_type_id}
                  onChange={handleAreaTypeId}
                  error={!!errors.area_type_id}
                  helperText={errors.area_type_id || ''}
                >
                  {tiposAreaState.data.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <hr />
              <hr />
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    crearArea();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={editarState.open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR AREA</h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  error={!!errors.name}
                  helperText={errors.name || ""}
                  id="textFile-nombre"
                  label="NOMBRE ÁREA"
                  variant="outlined"
                  value={editarState.data.name}
                  onChange={handleSeleccionadaName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  error={!!errors.liable}
                  helperText={errors.liable || ""}
                  id="textFile-nombre"
                  label="RESPONSABLE"
                  variant="outlined"
                  value={editarState.data.liable}
                  onChange={handleSeleccionadaLiable}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="MUNICIPIO" 
                  variant="outlined" 
                  select 
                  error={!!errors.municipality}
                  helperText={errors.municipality || ""}
                  value={editarState.data.municipality}
                  onChange={handleSeleccionadaMunicipality}
                >
                  
                  <MenuItem value="MORELIA">MORELIA</MenuItem>
                  <MenuItem value="APATZINGÁN">APATZINGÁN</MenuItem>
                  <MenuItem value="LÁZARO CÁRDENAS">LÁZARO CÁRDENAS</MenuItem>
                  <MenuItem value="LA PIEDAD">LA PIEDAD</MenuItem>
                  <MenuItem value="SAHUAYO">SAHUAYO</MenuItem>
                  <MenuItem value="URUAPAN">URUAPAN</MenuItem>
                  <MenuItem value="ZAMORA">ZAMORA</MenuItem>
                  <MenuItem value="ZITÁCUARO">ZITÁCUARO</MenuItem>
                  
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="PUESTO"
                  variant="outlined"
                  error={!!errors.post}
                  helperText={errors.post || ""}
                  value={editarState.data.post}
                  onChange={handleSeleccionadaPost}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  error={!!errors.phone}
                  helperText={errors.phone || ""}
                  id="textFile-nombre"
                  label="TELÉFONO"
                  variant="outlined"
                  value={editarState.data.phone}
                  onChange={handleSeleccionadaPhone}
                  inputProps={{ maxLength: 150 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  error={!!errors.email}
                  helperText={errors.email || ""}
                  id="textFile-nombre"
                  label="CORREO ELECTRÓNICO"
                  variant="outlined"
                  value={editarState.data.email}
                  onChange={handleSeleccionadaEmail}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
             <Grid item xs={12}>
                <TextField
                  required
                  select
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  error={!!errors.area_type_id}
                  helperText={errors.area_type_id || ""}
                  size="small"
                  id="textFile-nombre"
                  label="TIPO DE ÁREA"
                  variant="outlined"
                  value={editarState.data.area_type_id || ""}
                  onChange={handleSeleccionadaAreaTypeId}
                >
                  <MenuItem value="">{handleSeleccionadaAreaTypeId}</MenuItem>
                  {tiposAreaState.data.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarArea();
                  }}
                >
                  Editar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openModalEliminar}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas  mb-5">
              ¿ESTÁ SEGURO DE ELIMINAR EL AREA?
            </h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>{state.areaSeleccionada.name}</h4>
              </Grid>

              <Grid margin="auto" item>
                <ColorButton
                  onClick={() => {
                    eliminarArea();
                  }}
                >
                  Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AreasView;
